import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';

// Styles
import './SettingsContainer.scss';

type Props = {
  title: string;
  subTitle?: string;
  children: React.ReactNode;
};

const SettingsContainer = ({ title, subTitle, children }: Props) => {
  const baseClassName = 'SettingsContainer';
  return (
    <WpContainer className={`${baseClassName}`}>
      <WpContainerBody>
        <p className={`${baseClassName}__title`}>{title}</p>
        {subTitle && <p className={`${baseClassName}__description`}>{subTitle}</p>}
        <div className={`${baseClassName}__body`}>{children}</div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default SettingsContainer;
